import { useTranslation } from 'react-i18next';

import { sessionStore } from '~atoms/sessionAtom';
import { generalInformation, login } from '~constants';
import { UsersService } from '~features/users';
import { GeneralLoaderWrapper } from '~layouts';
import { getService } from '~services/serviceFactory';

import { parseAuthenticationResultToOidcTokens } from '../interfaces/tokenResponseType';

/**
 * A post-login page to show feedback for the user while finishing his
 * login process
 */
const LoginCallbackPage = () => {
	const session = sessionStore;
	const { t } = useTranslation('auth');
	session.setLoadingUser(true, true);

	sessionStore.setLoadingUser(true, true);
	login.msalInstance
		.initialize()
		.then(async () => {
			const tokens = await login.msalInstance.handleRedirectPromise({
				navigateToLoginRequestUrl: false,
			});

			// After the token are set and the user is loaded, the [PublicRoute] will notice
			// we now have a session, and redirect to the dashboard.
			if (tokens) {
				sessionStore.setOidcTokens(parseAuthenticationResultToOidcTokens(tokens));
				const usersService = getService(UsersService);
				const connectUser = await usersService.getCurrentUser();
				sessionStore.setConnectUser(connectUser);
			}
		})
		.finally(() => {
			sessionStore.setLoadingUser(false, false);
		});

	return (
		<GeneralLoaderWrapper title={`${t('messages.welcomeTo')} ${generalInformation.AppName}`} />
	);
};

export default LoginCallbackPage;
